import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram, Facebook, Linkedin } from "lucide-react";
import { CLINIC, SERVICES } from "../lib/data";

const iconMap = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin };

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-16 pb-10">
        <div className="border-b border-white/10 pb-12 mb-12">
          <h2 className="font-display text-4xl sm:text-6xl font-bold tracking-tight text-white">
            Move Better.<br />Recover Faster.
          </h2>
          <Link
            to="/book"
            data-testid="footer-book-button"
            className="mt-7 inline-flex items-center rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-navy transition-all hover:-translate-y-0.5"
          >
            Book Your Appointment
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="font-display font-bold text-lg">Arena Movement</div>
            <p className="mt-3 text-sm text-white/60 leading-relaxed max-w-xs">
              Evidence-based physiotherapy & movement-based care for active people across Melbourne.
            </p>
            <div className="mt-5 flex gap-3">
              {CLINIC.socials.map((s) => {
                const Icon = iconMap[s.icon];
                return (
                  <a key={s.label} href={s.url} target="_blank" rel="noreferrer" aria-label={s.label} data-testid={`footer-social-${s.icon}`}
                     className="h-9 w-9 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors">
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/50">Services</div>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-sm text-white/70 hover:text-white transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/50">Explore</div>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/about" className="text-sm text-white/70 hover:text-white">About</Link></li>
              <li><Link to="/team" className="text-sm text-white/70 hover:text-white">Meet the Team</Link></li>
              <li><Link to="/blog" className="text-sm text-white/70 hover:text-white">Blog</Link></li>
              <li><Link to="/contact" className="text-sm text-white/70 hover:text-white">Contact</Link></li>
              <li><Link to="/book" className="text-sm text-white/70 hover:text-white">Book Online</Link></li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-white/50">Visit Us</div>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li className="flex gap-2.5"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />{CLINIC.address}</li>
              <li><a href={`tel:${CLINIC.phoneIntl}`} className="flex gap-2.5 hover:text-white"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />{CLINIC.phone}</a></li>
              <li><a href={`mailto:${CLINIC.email}`} className="flex gap-2.5 hover:text-white"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />{CLINIC.email}</a></li>
              <li className="flex gap-2.5"><Clock className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />Mon 9am–5pm</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Arena Movement Physiotherapy. All rights reserved.</span>
          <span>Highett & Sandringham, Victoria, Australia</span>
        </div>
      </div>
    </footer>
  );
}
